import { render, staticRenderFns } from "./AddInsPoint.vue?vue&type=template&id=7c31c736&scoped=true"
import script from "./AddInsPoint.vue?vue&type=script&lang=js"
export * from "./AddInsPoint.vue?vue&type=script&lang=js"
import style0 from "./AddInsPoint.vue?vue&type=style&index=0&id=7c31c736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c31c736",
  null
  
)

export default component.exports